import { format } from "date-fns";

// Must match UNITS in the Food Cost worker (src/lib/constants.ts); it rejects
// any unit it can't convert.
export const COMMON_UNITS = [
  "each",
  "dozen",
  "oz",
  "lb",
  "g",
  "kg",
  "tsp",
  "tbsp",
  "fl oz",
  "cup",
  "pint",
  "quart",
  "gallon",
  "ml",
  "liter",
  "case",
  "bag",
  "can",
  "bottle",
  "keg",
] as const;

/** True when a menu cost is missing at least one ingredient. */
export function isIncompleteCost(cost: { costComplete?: boolean }): boolean {
  return cost.costComplete === false;
}

export function money(value: number | null): string {
  if (value === null || value === undefined) return "-";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * A per-unit cost. Small amounts keep up to 4 decimals so $0.0333/fl oz
 * doesn't round to $0.03.
 */
export function unitMoney(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "-";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: Math.abs(value) < 1 ? 4 : 2,
  }).format(value);
}

export const COST_SOURCE_LABEL = {
  invoice: "from latest invoice",
  batch: "from batch recipe",
  override: "manual cost",
} as const;

export function pct(value: number | null): string {
  if (value === null || value === undefined) return "-";
  return `${(value * 100).toFixed(1)}%`;
}

export function shortDate(value: string | null): string {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return format(d, "MMM d, yyyy");
}
